module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('rate-component', {
    attrs: {
      "selected-subsidiary": _vm.subsidiaryId,
      "read-only": _vm.readOnly,
      "alreadyExistRate": _vm.customerWhithRate,
      "rates": _vm.rates
    },
    on: {
      "rate-selected": _vm.rateSelected,
      "subsidiary-select": _vm.roomSubsidiaryModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6959b91a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/bookings/sub-component/RateModal.vue
// module id = 1659
// module chunks = 1